import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/sheet';
import { Menu } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  
  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const closeMobileMenu = () => {
    setIsOpen(false);
  };

  const handleNavigation = (sectionId) => {
    closeMobileMenu();
    
    navigate(`/#${sectionId}`);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <a 
            href="https://www.mnvsolutions.co.in/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex items-center gap-3"
          >
            <img 
              src="/assets/mnv-logo.png" 
              alt="MNV Solutions" 
              className="h-12 w-auto object-contain"
            />
            <span className="text-xl font-bold text-gray-900 hidden sm:block">MNV Solutions</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link 
              to="/" 
              className={`font-medium transition-colors ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Pricing
            </Link>
            <Link 
              to="/services" 
              className={`font-medium transition-colors ${
                isActive('/services') ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
              }`}
            >
              Services
            </Link>
            <button 
              onClick={() => handleNavigation('features')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Features
            </button>
            <button 
              onClick={() => handleNavigation('faq')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              FAQ
            </button>
            <button 
              onClick={() => handleNavigation('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Contact
            </button>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Button asChild variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50">
              <a href="https://www.waba.mnvsolutions.co.in/login">Sign In</a>
            </Button>
            <Button onClick={() => handleNavigation('contact')} className="bg-blue-600 hover:bg-blue-700 text-white">
              Book a Demo
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <button className="md:hidden text-gray-700 p-2">
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[400px]">
              <SheetHeader>
                <SheetTitle className="text-left">Menu</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-4 mt-8">
                <Link 
                  to="/" 
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-2 px-4 rounded-lg transition-colors ${
                    isActive('/') ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  Pricing
                </Link>
                <Link 
                  to="/services" 
                  onClick={closeMobileMenu}
                  className={`text-lg font-medium py-2 px-4 rounded-lg transition-colors ${
                    isActive('/services') ? 'bg-blue-50 text-blue-600' : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  Services
                </Link>
                <button 
                  onClick={() => handleNavigation('features')}
                  className="text-lg font-medium py-2 px-4 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors text-left w-full"
                >
                  Features
                </button>
                <button 
                  onClick={() => handleNavigation('faq')}
                  className="text-lg font-medium py-2 px-4 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors text-left w-full"
                >
                  FAQ
                </button>
                <button 
                  onClick={() => handleNavigation('contact')}
                  className="text-lg font-medium py-2 px-4 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors text-left w-full"
                >
                  Contact
                </button>
                
                <div className="flex flex-col gap-3 mt-6 pt-6 border-t border-gray-200">
                  <Button 
                    asChild
                    variant="outline"
                    className="w-full border-blue-600 text-blue-600 hover:bg-blue-50"
                  >
                    <a href="https://www.waba.mnvsolutions.co.in/login" onClick={closeMobileMenu}>Sign In</a>
                  </Button>
                  <Button 
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={() => handleNavigation('contact')}
                  >
                    Book a Demo
                  </Button>
                </div>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;